import React from "react"

import styles from "./navbutton.module.css"
import { Link } from "gatsby"
import { genSlug } from "../../utils/paths"

export function NavButton({
  dropDownValues,
  label,
  to = "#",
  useAnchor = false,
  className = "",
  isSideContact = false,
}: {
  dropDownValues?: Array<any>
  label: string
  to?: string
  useAnchor?: boolean
  className?: string
  isSideContact?: boolean
}) {
  return (
    <div className={`${styles.dropdown} ${className}`}>
      {useAnchor ? (
        <a
          href={to}
          className={`${isSideContact ? styles.btn : styles.dropbtn}`}
        >
          {label}
        </a>
      ) : (
        <Link
          to={to}
          className={`${isSideContact ? styles.btn : styles.dropbtn}`}
        >
          {label}
        </Link>
      )}
      {dropDownValues != null && dropDownValues.length > 0 && (
        <div className={styles.dropdownContent}>
          {dropDownValues.map(node => {
            return (
              <Link
                key={genSlug(node.countyName)}
                to={genSlug(node.countyName)}
              >
                {node.countyName}
              </Link>
            )
          })}
        </div>
      )}
    </div>
  )
}
